module.exports = __webpack_public_path__ + "static/media/1.110f0c61.jpg";